import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Index } from "./pages/Index.tsx";
import { SiteForwardBadge } from "./components/ui/SiteForwardBadge.tsx";
import "./index.css";

// Lazy load non-critical routes
const About = lazy(() => import("./pages/About.tsx").then(module => ({ default: module.About })));
const Services = lazy(() => import("./pages/Services.tsx").then(module => ({ default: module.Services })));
const ModernizationReport = lazy(() => import("./pages/ModernizationReport").then(module => ({ default: module.ModernizationReport })));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/modernization-report" element={<ModernizationReport />} />
          </Routes>
        </Suspense>
        <SiteForwardBadge />
      </Router>
    </HelmetProvider>
  );
}

export default App;
